// @flow
// React Libs
import React from 'react';
// Components
import Tooltip from '../../../../../Resources/Common/Tooltip';
import SimpleDocumentComponent from '../../../Documents/SimpleDocumentComponent';

type Props = {
  hasRights: boolean,
  blocked: boolean,
  proposalUid: string
};

export default function PitchDeck({
  hasRights,
  blocked,
  proposalUid
}: Props) {
  return (
    <SimpleDocumentComponent
      title="Pitch Deck"
      tooltip={Tooltip.DocumentProjectPitchDeck.document}
      hasRights={hasRights}
      blocked={blocked}
      proposalUid={proposalUid}
    />
  );
}
